<div class="modal-header">
    <button type="button"  class="modal-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <svg _ngcontent-ng-c2324265264="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#E12829" viewBox="0 0 16 16" class="bi-x-lg"><path _ngcontent-ng-c2324265264="" fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"></path><path _ngcontent-ng-c2324265264="" fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"></path></svg>
    </button>
</div>
<div class="modal-body">
    <h4 class="modal-title">{{"PREORDER_MODAL.TITLE" | translate }}</h4>
    <div class="subtitle">
        <p [innerHTML]="'PREORDER_MODAL.SUBTITLE_1' | translate" class="subtitle--1">
        </p>  
        <p>
            {{"PREORDER_MODAL.SUBTITLE_2" | translate}}
        </p>
    </div>
   
    <div class="image-container">
        <img src="assets/preorder-guy.png" alt="Preorder img" class="preorder-img">

        <button class="btn green-button product-button" (click)="activeModal.dismiss()">
            <img width="22" height="22" src="./assets/icons/cart-white.webp" alt="cart">
            {{"PREORDER_MODAL.BUTTON" | translate}}
          </button>
    </div>
</div>
